import { render, staticRenderFns } from "./AIDigitalHuman.vue?vue&type=template&id=9b5e4470&scoped=true"
import script from "./AIDigitalHuman.vue?vue&type=script&lang=js"
export * from "./AIDigitalHuman.vue?vue&type=script&lang=js"
import style0 from "./AIDigitalHuman.vue?vue&type=style&index=0&id=9b5e4470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5e4470",
  null
  
)

export default component.exports